import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'genericMetricFormatter'
})
export class GenericMetricFormatterPipe implements PipeTransform {

  transform(value: number, conversionType: string, numericType?: number): string {
    let formatted: string = "";
    const _value = Number(value) || 0;

    //NumericType 1 is Number according to the enum in clearview-core\ClearView Data Models\Quality\QualityEnums.cs
    const _numericType = typeof numericType !== 'undefined' ? numericType : 1;

    switch (conversionType) {
      case "0": //Number
            if (_numericType === 0) { //Currency
                formatted = _value.toLocaleString(typeof CVCultureName !== 'undefined' ? CVCultureName : 'en-US', {
                    style: "currency",
                    currency: typeof CVISOCurrencySymbol !== 'undefined' ? CVISOCurrencySymbol : 'USD',
                    maximumFractionDigits: 2,
                })
            } else {
                formatted = this.formatWithSmartDecimals(_value);
            }
        break;
      case "1": //Second
            formatted = (_value % 1 == 0) ? _value.toString() : _value.toFixed(2);
        break;
      case "2": //Minute
        formatted = (_value / 60).toFixed(2);
        break;
      case "3": //Hour
        formatted = (Math.floor((_value / 3600) * 100) / 100).toString();
        break;
      case "4": //Time      
        var hours = parseInt(Math.floor(_value / 3600).toString());
        var minutes = parseInt(Math.floor((_value - (hours * 3600)) / 60).toString());
        var seconds = parseInt((_value - (hours * 3600) - (minutes * 60)).toString());

        var strHour = hours < 10 ? ("0" + hours) : hours;
        var strMinutes = minutes < 10 ? ("0" + minutes) : minutes;
        var strSecond = seconds < 10 ? ("0" + seconds) : seconds;

        formatted = strHour + ':' + strMinutes + ':' + strSecond;
        break;
      case "5": //Percent
        formatted = (_value*100).toFixed(2) + "%";
        break;
      default:
        formatted = this.formatWithSmartDecimals(_value);
        break;
    }

    return formatted;
  }

  private formatWithSmartDecimals(num: number): string {
    if (num % 1 === 0) {
        return num.toString();
    }

    const numStr = num.toString();
    const decimalPart = numStr.split('.')[1];
    
    if (!decimalPart) {
        return num.toString();
    }
    
    if (decimalPart.length === 1) {
        return num.toFixed(1);
    }
    
    return num.toFixed(2);
  }
}
